import { useState, useEffect } from "react";
import { LiveMap } from "@liveblocks/core";
import { useHistory } from "react-router";
import { getRoomStorage } from "../PublicBuilder";
import { getRoomId } from "../utils";

const useTLDrawStorage = () => {
  const url = new URL(window.location.href);
  const baseDocumentId = url.searchParams.get("baseDocumentId");
  const [storage, setStorage] = useState({ records: new LiveMap() });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    if (baseDocumentId) {
      // Always settle the `loading` flag — without a `.catch` here a
      // rejected fetch (e.g. Safari blocking the cross-site cookie on
      // Liveblocks' auth endpoint) would never call `setLoading(false)`
      // and the PublicBuilder loading gate would spin forever.
      getRoomStorage(getRoomId(baseDocumentId))
        .then((roomStorage: any) => {
          if (roomStorage) {
            setStorage(roomStorage);
          }
        })
        .catch((err) => {
          // Log the actual error so it doesn't surface as a blank
          // `[object Object]` in the console. Best-effort: we still
          // let the builder render with the default empty LiveMap.
          // eslint-disable-next-line no-console
          console.error("[useTLDrawStorage] base-document load failed:", err);
        })
        .finally(() => {
          setLoading(false);
        });
      // delete baseDocumentId from url
      //   url.searchParams.delete("baseDocumentId");
      //   history.replace(url.toString());
    } else {
      setLoading(false);
    }
  }, [baseDocumentId]);

  return { storage, loading };
};

export default useTLDrawStorage;
